import React, { useState, useEffect } from "react";
import {
  initiateAadhaarOtpProcess,
  verifyAadhaarOtp,
  downloadAbhaCard,
} from "./ABDMapi";
import moment from "moment";
import PatientAutocomplete from "./PatientAutocomplete";
import { IoCloseOutline } from "react-icons/io5";
import { motion } from "framer-motion";
import CustomSelect from "./CustomSelect";
import {
  createAppointmentWithoutOTP,
  serviceCreateAppointment,
  serviceHandleAddPatientSubmit,
} from "../services/api";
import { getClinicIdFromToken } from "../utils/tokenUtils";
import { addPatientValidation } from "../utils/validations/addPatientValidation";
import * as Yup from "yup";
import {
  calculateAgeR,
  calculateDateOfBirthFromAgeR,
} from "../utils/commonUtils";
import { showToast } from "../utils/toastUtils";
import { FaSpinner } from "react-icons/fa";
import dayjs from "dayjs";
import AntDatePicker from "./antDatepicker";

const AddPatientModal = ({
  isOpen,
  onClose,
  doctors,
  fetchAllAppointmentsForClinic,
}) => {
  const [activeTab, setActiveTab] = useState("patient");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [aadhaarOtp, setAadhaarOtp] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [abhaNumber, setAbhaNumber] = useState("");
  const [patientMobile, setPatientMobile] = useState("");
  const [abhaCardUrl, setAbhaCardUrl] = useState("");
  const [patient, setPatient] = useState("");
  const [patientDetails, setPatientDetails] = useState({});
  const [checkRelatedPatient, setCheckRelatedPatient] = useState(false);
  const [localSelectedDoctor, setLocalSelectedDoctor] = useState("");
  const [patientContactNumber, setPatientContactNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [weight, setWeight] = useState("");
  const [gender, setGender] = useState("");
  const [isNewRelatedPatient, setIsNewRelatedPatient] = useState(false);
  const [date_of_birth, setBirthDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [patientDetails, setPatientDetails] = useState({});

  const tabVariants = {
    active: {
      borderBottom: "2px solid #3863db", // Border for active tab
    },
    inactive: {
      borderBottom: "2px solid transparent", // Border for inactive tab
    },
  };

  useEffect(() => {
    if (abhaNumber) {
      setActiveTab("patient");
    }
  }, [abhaNumber]);

  // Close modal on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        handleClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  const handleDoctorChange = (doctorId) => {
    setLocalSelectedDoctor(doctorId);
  };

  const createAppointment = async (patientId, doctorId) => {
    let params = {
      patientId,
      doctorId,
      clinicId: getClinicIdFromToken(),
    };
    let response = await serviceCreateAppointment(params);
    if (response.status) {
      handleClose()
      fetchAllAppointmentsForClinic();
    }else{
      return response
    }
  };

  const handleAddPatientSubmit = async (patientData) => {
    const {
      name,
      age,
      weight,
      gender,
      patientContactNumber,
      localSelectedDoctor,
      abhaNumber,
      isNewRelatedPatient,
      patientDetails,
      date_of_birth,
    } = patientData;

    try {
      setIsSubmitting(true);
      await addPatientValidation.validate(
        {
          name,
          age,
          gender,
          patientContactNumber,
          localSelectedDoctor,
          date_of_birth,
        },
        { abortEarly: false }
      );
      if (checkRelatedPatient) {
        let params = {
          name: name,
          age: age,
          gender: gender,
          date_of_birth: date_of_birth,
          patientDetails,
        };
        const response = await serviceHandleAddPatientSubmit(params);
        if (response?.status) {
          if (response?.data?.added) {
            const newPatientId = response?.data?.patientId;
            // Book the appointment using the new patient ID
            await createAppointment(newPatientId, localSelectedDoctor);
          }
        }
      } else if (patientDetails && patientDetails?.patient_id) {
        // Book the appointment for the selected patient
       const responseCase =  await createAppointment(patientDetails.patient_id, localSelectedDoctor);
       if(!responseCase?.status){
         showToast(responseCase.message,"error")
       }  
      } else {
        // Create a new patient and book the appointment
        const patientDataToSubmit = {
          patient_name: name,
          patient_age: age,
          patient_weight: weight,
          gender: gender,
          patient_contact_number: patientContactNumber,
          abhaNumber: abhaNumber,
          date_of_birth: date_of_birth,
        };
        let response = await createAppointmentWithoutOTP(
          patientDataToSubmit,
          localSelectedDoctor,
          getClinicIdFromToken()
        );
        if (response?.status) {
          showToast(response.message, "success");
        } else {
          console.error("Failed to create appointment for new patient");
          showToast(response.message, "error");
        }
      }
      fetchAllAppointmentsForClinic();
      onClose();
      setName("");
      setAge("");
      setWeight("");
      setGender("");
      setBirthDate("");
      setPatientContactNumber("");
      setLocalSelectedDoctor("");
      setPatient("");
      setPatientDetails({});
      setErrorMessage({});
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        // Handle the validation error
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrorMessage(validationErrors);
      } else {
        console.error("Network error:", error);
        setErrorMessage({ customError: "Network error. Please try again." });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleLocalSubmit = async (e) => {
    e.preventDefault();
    await handleAddPatientSubmit({
      name,
      age,
      weight,
      gender,
      patientContactNumber: patient,
      localSelectedDoctor,
      abhaNumber,
      isNewRelatedPatient,
      patientDetails,
      date_of_birth,
    });
  };

  const handleAadhaarOtpRequest = async () => {
    try {
      const response = await initiateAadhaarOtpProcess(aadhaarNumber);
      setTransactionId(response.requestOtpResponse.txnId);
    } catch (error) {
      console.error("Error requesting Aadhaar OTP:", error);
    }
  };

  const handleAadhaarOtpVerify = async () => {
    try {
      const response = await verifyAadhaarOtp(
        aadhaarOtp,
        transactionId,
        patientMobile
      );
      setAbhaNumber(response.ABHAProfile.ABHANumber);

      // Prefill patient details
      const { firstName, lastName, dob, gender } = response.ABHAProfile;
      setName(`${firstName} ${lastName}`);
      setAge(moment().diff(moment(dob, "DD-MM-YYYY"), "years"));
      setGender(gender === "M" ? "Male" : "Female");
      setPatientContactNumber(patient.patientContactNumber);

      // Download the ABHA card
      const abhaCardBlob = await downloadAbhaCard(
        response.ABHAProfile.ABHANumber,
        response.tokens.token
      );
      const abhaCardUrl = URL.createObjectURL(abhaCardBlob);
      setAbhaCardUrl(abhaCardUrl);
    } catch (error) {
      console.error("Error verifying Aadhaar OTP:", error);
    }
  };

  const resetForm = () => {
    setName("");
    setAge("");
    setWeight("");
    setGender("");
    setPatientContactNumber("");
    setLocalSelectedDoctor("");
    setAadhaarNumber("");
    setAadhaarOtp("");
    setTransactionId("");
    setAbhaNumber("");
    setPatientMobile("");
    setAbhaCardUrl("");
    setPatientDetails({});
    setPatient("");
    setIsNewRelatedPatient(false);
    setCheckRelatedPatient(false);
    setBirthDate("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const CalculateAgeFromDate = (date) => {
    if(date){
    //setBirthDate(date);
    setBirthDate(dayjs(date).startOf('day').format("YYYY-MM-DD"));
    let localAge = calculateAgeR(date);
    setAge(localAge);
    }
  };

  const handleChangeAge = (event) => {
    if (isNaN(event.target.value)) {
      setAge("");
      showToast("Only number allowed", "error");
    } else {
      if(event.target.value < 1){
        let localDob = calculateDateOfBirthFromAgeR(age);
        setBirthDate(dayjs(localDob).format('YYYY-MM-DD'));
        CalculateAgeFromDate(dayjs(localDob).format('YYYY-MM-DD'))
      }
      let localDob = calculateDateOfBirthFromAgeR(age);
      setBirthDate(dayjs(localDob).format('YYYY-MM-DD'));
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-0 lg:top-20 mx-auto p-5 border shadow-lg rounded-md bg-white  w-full h-full lg:h-auto lg:w-[550px]">
            <div className="mt-2">
              <div className=" mb-5 flex justify-between">
                <span className="text-xl font-semibold text-gray-800 ">
                  {" "}
                  Add Patient
                </span>
                <button
                  onClick={handleClose}
                  className=" absolute right-3 top-3 text-gray-600 bg-gray-100 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-gray-200  hover:text-gray-800 px-0 w-10 h-10 inline-flex justify-center items-center rounded-full text-2xl m-1.5"
                >
                  <IoCloseOutline />
                  <span className="sr-only">Icon description</span>
                </button>
              </div>
              <div className="flex  ">
                {/* <div
              className={`w-1/2 p-4 cursor-pointer text-center ${
                activeTab === "patient"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-800"
              }`}
              onClick={() => setActiveTab("patient")}
            >
              Patient Details
            </div>
            <div
              className={`w-1/2 p-4 cursor-pointer text-center ${
                activeTab === "abdm"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-800"
              }`}
              onClick={() => setActiveTab("abdm")}
            >
              ABDM
            </div> */}

                <motion.div
                  className={`w-1/2 p-4  py-3 cursor-pointer text-center ${
                    activeTab === "patient"
                      ? "bg-blue-500/10 text-blue-700 shadow-md"
                      : " bg-transparent text-gray-800"
                  }`}
                  onClick={() => setActiveTab("patient")}
                  initial="inactive" // Initial animation state
                  animate={activeTab === "patient" ? "active" : "inactive"} // Apply animation based on activeTab
                  variants={tabVariants} // Variants for border animation
                  transition={{ duration: 0.2 }} // Animation duration
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                >
                  {/* Content for the "patient" tab */}
                  Patient Details
                </motion.div>
                <motion.div
                  className={`w-1/2 p-4  py-3 cursor-pointer text-center ${
                    activeTab === "abdm"
                      ? "bg-blue-500/10 text-blue-700 shadow-md"
                      : " bg-transparent text-gray-800"
                  }`}
                  onClick={() => setActiveTab("abdm")}
                  initial="inactive" // Initial animation state
                  animate={activeTab === "abdm" ? "active" : "inactive"} // Apply animation based on activeTab
                  variants={tabVariants} // Variants for border animation
                  transition={{ duration: 0.2 }} // Animation duration
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                >
                  {/* Content for the "abdm" tab */}
                  ABDM
                </motion.div>
              </div>

              <div className=" border mt-[-1px]">
                {activeTab === "patient" && (
                  <motion.div
                    className="w-full"
                    initial={{ opacity: 0, x: 0, overflow: "hidden" }}
                    animate={{ opacity: 1, x: 0, overflow: "visible" }}
                    transition={{ duration: 0.3 }}
                  >
                    <form
                      className="space-y-6 p-6 px-6 "
                      onSubmit={handleLocalSubmit}
                    >
                      <div className="grid grid-cols-2 gap-4">
                        <div className="col-span-2">
                          <label
                            htmlFor="mobile"
                            className="block text-gray-700 text-sm mb-1"
                          >
                            Mobile Number
                          </label>
                          <PatientAutocomplete
                            patient={patient}
                            setPatient={setPatient}
                            patientDetails={patientDetails}
                            setPatientDetails={setPatientDetails}
                            setName={setName}
                            setGender={setGender}
                            setAge={setAge}
                            setBirthDate={setBirthDate}
                            isNewRelatedPatient={isNewRelatedPatient}
                            setIsNewRelatedPatient={setIsNewRelatedPatient}
                            checkRelatedPatient={checkRelatedPatient}
                            setCheckRelatedPatient={setCheckRelatedPatient}
                            resetForm={resetForm}
                          />
                          <div className=" text-sm text-red-500">
                            {errorMessage?.patientContactNumber}
                          </div>
                        </div>
                        <div className="col-span-2">
                          <label
                            htmlFor="name"
                            className="block text-gray-700 text-sm mb-1"
                          >
                            Patient Name
                          </label>
                            <input
                              type="text"
                              id="name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              // required
                              disabled={
                                patientDetails &&
                                patientDetails.patient_id &&
                                patientDetails.full_name &&
                                isNewRelatedPatient !== true
                              }
                              className="w-full px-3 py-2 border rounded-md text-gray-700"
                          />
                          <div className=" text-sm text-red-500">
                            {errorMessage?.name}
                          </div>
                        </div>
                        <div className="col-span-2">
                          <label
                            htmlFor="gender"
                            className="block text-gray-700 text-sm mb-1"
                          >
                            Gender
                          </label>
                          <div className="flex space-x-4">
                            <button
                              type="button"
                              disabled={
                                patientDetails &&
                                patientDetails.patient_id &&
                                patientDetails.gender &&
                                isNewRelatedPatient !== true
                              }
                              className={`px-4 py-2 rounded-md ${
                                gender === "Male"
                                  ? "bg-blue-500 text-white"
                                  : "bg-gray-200 text-gray-700"
                              }`}
                              onClick={() => setGender("Male")}
                            >
                              Male
                            </button>
                            <button
                              type="button"
                              disabled={
                                patientDetails &&
                                patientDetails.patient_id &&
                                patientDetails.gender &&
                                isNewRelatedPatient !== true
                              }
                              className={`px-4 py-2 rounded-md ${
                                gender === "Female"
                                  ? "bg-blue-500 text-white"
                                  : "bg-gray-200 text-gray-700"
                              }`}
                              onClick={() => setGender("Female")}
                            >
                              Female
                            </button>
                            <button
                              type="button"
                              disabled={
                                patientDetails &&
                                patientDetails.patient_id &&
                                patientDetails.gender &&
                                isNewRelatedPatient !== true
                              }
                              className={`px-4 py-2 rounded-md ${
                                gender === "Other"
                                  ? "bg-blue-500 text-white"
                                  : "bg-gray-200 text-gray-700"
                              }`}
                              onClick={() => setGender("Other")}
                            >
                              Other
                            </button>
                          </div>
                          <div className=" text-sm text-red-500">
                            {errorMessage?.gender}
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="age"
                            className="block text-gray-700 text-sm mb-1"
                          >
                            Age
                          </label>
                          <input
                            type="text"
                            id="age"
                            value={age}
                            onChange={(e) => setAge(e.target.value)}
                            onBlur={handleChangeAge}
                            // required
                            // disabled={isNewRelatedPatient ? false : true}
                            disabled={
                              patientDetails &&
                              patientDetails.patient_id &&
                              patientDetails.age &&
                              isNewRelatedPatient !== true
                            }
                            className="w-full px-3 py-2 border rounded-md text-gray-700"
                          />
                          {/*  <div className=" text-sm text-red-500">
                            {errorMessage?.age}
                          </div> */}
                        </div>

                        <div className="w-full  px-3">
                          <label className="block text-gray-700 text-sm mb-1">
                            Date of birth
                          </label>

                        <AntDatePicker
                          defaultValue={null}
                          placeholder="select date"
                          value={date_of_birth?dayjs(date_of_birth):''}
                          onChange={(dateString) => CalculateAgeFromDate(dateString)}
                          disabledFutureDate={true}
                          disabled={
                            patientDetails &&
                            patientDetails.patient_id &&
                            patientDetails.gender &&
                            isNewRelatedPatient !== true
                          }
                        />

                          {errorMessage?.date_of_birth != "" && (
                            <div className=" text-red-500 text-sm">
                              {errorMessage?.date_of_birth}
                            </div>
                          )}
                        </div>

                        <div className="col-span-2">
                          <label
                            htmlFor="doctor"
                            className="block text-gray-700 text-sm mb-1"
                          >
                            Doctor
                          </label>

                          <CustomSelect
                            id="doctor"
                            value={localSelectedDoctor}
                            isSearchable={true}
                            isClearable={false}
                            isDisabled={false}
                            className={" w-full form_select"}
                            placeholder={"Select Doctor"}
                            menuPosition={"absolute"}
                            onChange={(e) => {
                              setLocalSelectedDoctor(e.value);
                            }}
                            // required
                            options={doctors.map((doctor) => ({
                              value: doctor.doctor_id,
                              label: `${doctor.first_name} ${doctor.last_name}`,
                            }))}
                          />
                          <div className=" text-sm text-red-500">
                            {errorMessage?.localSelectedDoctor}
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 flex justify-center"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <FaSpinner size={20} className="animate-spin" />
                        ) : (
                          "Add Patient"
                        )}
                      </button>
                    </form>
                  </motion.div>
                )}
                {activeTab === "abdm" && (
                  <motion.div
                    className="w-full"
                    initial={{ opacity: 0, x: 0, overflow: "hidden" }}
                    animate={{ opacity: 1, x: 0, overflow: "visible" }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="p-6 px-6 ">
                      <div className="mb-6">
                        <label
                          htmlFor="aadhaarNumber"
                          className="block text-gray-700 text-sm mb-1"
                        >
                          Aadhaar Number
                        </label>
                        <input
                          type="text"
                          id="aadhaarNumber"
                          value={aadhaarNumber}
                          onChange={(e) => setAadhaarNumber(e.target.value)}
                          // required
                          className="w-full px-3 py-2 border rounded-md text-gray-700"
                        />
                      </div>
                      <button
                        onClick={handleAadhaarOtpRequest}
                        className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 mb-6"
                      >
                        Request Aadhaar OTP
                      </button>
                      {transactionId && (
                        <>
                          <div className="mb-6">
                            <label
                              htmlFor="aadhaarOtp"
                              className="block text-gray-700 text-sm mb-1"
                            >
                              Aadhaar OTP
                            </label>
                            <input
                              type="text"
                              id="aadhaarOtp"
                              value={aadhaarOtp}
                              onChange={(e) => setAadhaarOtp(e.target.value)}
                              // required
                              className="w-full px-3 py-2 border rounded-md text-gray-700"
                            />
                          </div>
                          <div className="mb-6">
                            <label
                              htmlFor="patientMobile"
                              className="block text-gray-700 text-sm mb-1"
                            >
                              Mobile Number of Patient
                            </label>
                            <input
                              type="text"
                              id="patientMobile"
                              value={patientMobile}
                              onChange={(e) => setPatientMobile(e.target.value)}
                              // required
                              className="w-full px-3 py-2 border rounded-md text-gray-700"
                            />
                          </div>
                          <button
                            onClick={handleAadhaarOtpVerify}
                            className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600"
                          >
                            Verify Aadhaar OTP
                          </button>
                        </>
                      )}
                      {abhaNumber && (
                        <div className="mt-6">
                          <p className="text-lg mb-2">
                            ABHA Number: {abhaNumber}
                          </p>
                          {abhaCardUrl && (
                            <div className="flex justify-center">
                              <img
                                src={abhaCardUrl}
                                alt="ABHA Card"
                                className="max-w-xs"
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </motion.div>
                )}
              </div>
              {/* <div className="flex justify-end p-6">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none"
            >
              Close
            </button>
          </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddPatientModal;
